import { reactive, computed } from 'vue';

export default function IndependentDriverSignupVerification(data = {}) {
  const state = reactive({
    emailVerified: data.emailVerified || false,
    phoneVerified: data.phoneVerified || false,
  });

  const validations = {
    isEmailVerified: computed(() => state.emailVerified === true),
    isPhoneVerified: computed(() => state.phoneVerified === true),
  };

  // Both, not either: a bitwise OR here let the wizard past this step with one side unverified,
  // and the signup was then refused at submission time by a server that checks both.
  const isValid = () => validations.isEmailVerified.value && validations.isPhoneVerified.value;

  const toJSON = () => ({ ...state });

  return { state, validations, isValid, toJSON };
}
